
import React, { useState, useEffect, useContext } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import tmdbApi from "../../api/tmdbApi";
import SessionPopup from "../../pages/SessionPopup"
import axios from 'axios';
import moment from "moment";
import Modal from 'react-bootstrap/Modal';

import Select from 'react-select';
import Loader from "../../components/loader";
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../../context/contentContext";
import * as Config from "../../constants/Config";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ROLE_REFUSED, USER_TYPES, isMenuBlocked, userTypeLabel, withRoleLimits } from "../../utils/adminRoles";
let { lambda, country, appname } = window.app;

const EditUser = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const [msg, setMsg] = useState("");
    const [countries, setCountries] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isUserAdd, setIsUserAdd] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [nameError, setNameError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [IdcError, setIdcError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [statusErr, setStatusErr] = useState('');
    const [toastType, setToastType] = useState("");// State for dynamic message
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [managertypeError, setManagerTypeError] = useState('');
    const [editUser, setEditUser] = useState({ name: '', phone: '', userType: '', status: '', idc: '' });
    const [permission, setPermission] = useState({});
    const [success, setSuccess] = useState(false);
    const [UpdateSuccess, setUpdateSuccess] = useState(false);
    const [image, setImg] = useState('');
    const [manager, setManagers] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [existmsg, setExistMsg] = useState(false);
    const [Ismsg, setIsMsg] = useState(false);
    const [checkStatus, setCheckStatus] = useState(false);
    const [invalidContent, setInvalidContent] = useState(false);
    const { route, setRoute, setCurrentPage, setRowsPerPage, setActiveMenuObj, usePrevious, userData, setActiveMenuId, GetTimeActivity } = useContext(contentContext);
    const [isServerSync, setIsServerSync] = useState(false);

    const [initialPermissions, setInitialPermissions] = useState([]);

    const [initialUser, setInitialUser] = useState(null);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [showDiscardModal, setShowDiscardModal] = useState(false);
    const [pendingAction, setPendingAction] = useState(null);
    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (editUser && Object.keys(editUser).length > 0) {
            setInitialUser(JSON.stringify(editUser));
            setHasUnsavedChanges(false);
        }
    }, [editUser?._id]); // or unique identifier

    useEffect(() => {
        if (id === undefined && !initialUser) {
            // Add mode - set initial empty state
            const initialAddState = { name: '', phone: '', userType: '', status: '', emailid: '', idc: 'USA' };
            setInitialUser(JSON.stringify(initialAddState));
            setHasUnsavedChanges(false);
        }
    }, [id, initialUser]);

    console.log('editUser?.id', editUser?._id)
    const markDirty = (updatedUser) => {
        if (!initialUser) return;
        const isChanged = JSON.stringify(updatedUser) !== initialUser;
        setHasUnsavedChanges(isChanged);
    };
    const markPermissionDirty = (updatedPermissions) => {
        if (!initialPermissions || initialPermissions.length === 0) return;

        const isChanged =
            JSON.stringify(updatedPermissions) !==
            JSON.stringify(initialPermissions);

        setHasUnsavedChanges(isChanged);
    };





    const handleDiscardChanges = () => {
        if (initialUser) {
            setEditUser(JSON.parse(initialUser));
        }
        setHasUnsavedChanges(false);
        setShowDiscardModal(false);

        if (pendingAction) {
            pendingAction();
            setPendingAction(null);
        }
    };
 
    const handleUpdateFromModal = () => {
        setShowDiscardModal(false);

        if (id !== undefined) {
            handleUpdate(); // Edit mode
        } else {
            handleAddUser(); // Add mode
        }
    };
    useEffect(() => {
        const handler = (e) => {
            if (!hasUnsavedChanges) return;
            e.preventDefault();
            e.returnValue = "";
        };

        window.addEventListener("beforeunload", handler);
        return () => window.removeEventListener("beforeunload", handler);
    }, [hasUnsavedChanges]);


    useEffect(() => {
        console.log("Unsaved changes:", hasUnsavedChanges);
    }, [hasUnsavedChanges]);


    const guardUnsavedChanges = (action) => {
        if (hasUnsavedChanges) {
            setPendingAction(() => action);
            setShowDiscardModal(true);
        } else {
            action();
        }
    };


    useEffect(() => {
        window.__HAS_UNSAVED_CHANGES__ = hasUnsavedChanges;

        window.__SHOW_UNSAVED_MODAL__ = (action) => {
            setPendingAction(() => action);
            setShowDiscardModal(true);
        };

        return () => {
            window.__HAS_UNSAVED_CHANGES__ = false;
            window.__SHOW_UNSAVED_MODAL__ = null;
        };
    }, [hasUnsavedChanges]);


    useEffect(() => {
        if (isServerSync && editUser && Object.keys(editUser).length > 0 && Array.isArray(permission) && id !== undefined) {
            setInitialUser(JSON.stringify(editUser));
            setInitialPermissions(
                JSON.parse(JSON.stringify(permission))
            );
            setHasUnsavedChanges(false);
            setPendingAction(null);

            // reset sync flag
            setIsServerSync(false);
        }
    }, [editUser, isServerSync, permission, id]);
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);

    useEffect(() => {
        if (toastMessage && toastType && toast[toastType]) {
            toast[toastType](toastMessage, {
                position: "bottom-center",
                // autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage && setToastMessage("");
        }
    }, [toastMessage, toastType]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(200003)

        setRoute("user")
        if (id) {
            getuser();


        }
        // getManagers();
        GetCountries();
        userActivity();
    }, []);

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = id !== undefined ? path[path.length - 2] : path[path.length - 1];;
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }

    const GetCountries = async () => {
        try {
            console.log(tmdbApi);
            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                // "projection":"tiny"
            });

            // console.log(response?.result);
            if (response?.result.data === "Invalid token or Expired") {
                setShowSessionPopupup(true)
            } else {
                setCountries(response?.result.data);
                const usaCountry = response?.result.data.filter(
                    eachItem => eachItem.countrycode.trim() === "(+1)" && eachItem.alpha2.trim() === "US"
                );
                if (!id) {
                    setEditUser((prevUser) => ({
                        ...prevUser,
                        idc: usaCountry?.[0]?.alpha3 || ""
                    }));
                }



            }
        } catch {
            console.log("error");
        }
    };
    console.log("editUser-------------------->", editUser)
    const getuser = (e) => {
        GetTimeActivity()
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/userInfo?appname=' + appname + '&userid=' + id + '&loginType=' + "admin" + "&token=" + token,
        })
            .then(function (response) {
                //  console.log("response", response?.data?.result?.[0]);
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                }
                else {
                    if (response?.data?.result.length > 0) {
                        setEditUser(response?.data?.result?.[0]);
                        // if (response?.data?.result?.[0] && response?.data?.result?.[0]?.permissions) {
                        //     setPermission(response?.data?.result?.[0]?.permissions)
                        // }

                        if (response?.data?.result?.[0]?.permissions) {
                            // Shown (and saved) as the role allows, so a Manager saved before
                            // the finance menus were blocked reads as it now works.
                            const limited = withRoleLimits(response?.data?.result?.[0]?.userType, response?.data?.result?.[0]?.permissions);
                            setPermission(limited);

                            // ADD THIS
                            setInitialPermissions(
                                JSON.parse(JSON.stringify(limited))
                            );
                        }

                        // ADD THIS
                        setInitialUser(JSON.stringify(response?.data?.result?.[0]));
                        setHasUnsavedChanges(false);
                    } else {
                        setInvalidContent(true)
                    }
                }
                // getPermissions(response?.data && response?.data?.result && response?.data?.result?.[0] && response?.data?.result?.[0]?.type)
            });
    }

    const onclickInvalid = () => {
        GetTimeActivity()
        setInvalidContent(false)
        navigate('/usermanagement')
    }

    const getManagers = (e) => {
        GetTimeActivity()
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/users?appname=' + appname + "&token=" + token + "&type=MANAGER",
        })
            .then(function (response) {
                console.log(response);
                setManagers(response?.data?.result)
            });
    }



    const getPermissions = (userType) => {
        GetTimeActivity()
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/userPermissions?appname=' + appname + '&type=' + userType
            // + "&token=" + token,
        })
            .then(function (response) {
                console.log("response?.data?.result?.data[0]", response?.data?.result?.data[0])
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setPermission(withRoleLimits(userType, response?.data?.result?.data?.[0]?.permissions))
                }
            });
    }

    const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        // setIdc(newCountry); // Update state

        setEditUser((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));

    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log('typeeeeeeeeee', value);
        console.log('nameeeee', name);

        if (name === "userType") {
            if (id) {
                setCheckStatus(true);
            }
            getPermissions(value);
            // setEditUser(prev => ({ ...prev, [name]: value }));
            setEditUser(prev => {
                const updated = { ...prev, [name]: value };
                markDirty(updated);
                return updated;
            });
            return;
        }

        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = editUser?.idc?.trim(); // Remove unnecessary spaces

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }

            // Update the phone number only
            // setEditUser(prev => ({ ...prev, phone: formattedValue }));
            setEditUser(prev => {
                const updated = { ...prev, phone: formattedValue };
                markDirty(updated);
                return updated;
            });
            return; // Stop further execution for "phone" field
        }

        else if (name === "manager") {
            for (let key in manager) {
                if (manager.hasOwnProperty(key) && manager[key].userid === value) {
                    // setEditUser(prev => ({ ...prev, [name]: value }));
                    setEditUser(prev => {
                        const updated = { ...prev, [name]: value };
                        markDirty(updated);
                        return updated;
                    });
                    return;
                    break; // No need to continue looping after finding the match
                }
            }
        }

        else if (name === "status") {
            if (id) {
                setCheckStatus(true);
            }
            // setEditUser(prev => ({ ...prev, [name]: value }));
            setEditUser(prev => {
                const updated = { ...prev, [name]: value };
                markDirty(updated);
                return updated;
            });
        }

        else {
            // setEditUser(prev => ({ ...prev, [name]: value }));
            setEditUser(prev => {
                const updated = { ...prev, [name]: value };
                markDirty(updated);
                return updated;
            });
        }
    };



    const handleAddUser = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            createuser();
        }
    }

    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;
        if (editUser?.emailid === undefined || editUser?.emailid?.trim() === "") {
            setEmailError("Please enter Email");
            setTimeout(function () { setEmailError("") }, 3000);
            formIsValid = false;
        }
        const regEx = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;
        if (regEx.test(editUser?.emailid)) {
            setEmailError("");
            setTimeout(function () { setEmailError("") }, 3000)
        } else if (!regEx.test(editUser?.emailid) && editUser?.emailid !== "") {
            setEmailError("Please Enter Valid Email");
            setTimeout(function () { setEmailError("") }, 3000)
            formIsValid = false;
        }

        if (editUser?.name === undefined || editUser?.name?.trim() === "") {
            setNameError("Please enter Name");
            setTimeout(function () { setNameError("") }, 3000);
            formIsValid = false;
        }
        if (!editUser?.phone?.trim()) {
            setPhoneError("Enter phone number");
            setTimeout(() => setPhoneError(""), 3000);
            formIsValid = false;
        } else
            if (
                (editUser.idc?.trim() === "USA" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(editUser.phone)) ||
                (editUser.idc.trim() === "IND" && !/^\d{5}-\d{5}$/.test(editUser.phone))
            ) {
                setPhoneError("Invalid phone number format");
                setTimeout(() => setPhoneError(""), 3000);
                formIsValid = false;
            }
        if (editUser?.userType === "") {
            setTypeError("Please select Type");
            setTimeout(function () { setTypeError("") }, 3000);
            formIsValid = false;
        }

        return formIsValid;
    }


    const handleSubmit = () => {
        GetTimeActivity()
        setIsLoading(true)

        const token = localStorage.getItem("token")
        let payload = {}
        payload = {
            "emailid": editUser?.emailid?.trim(),
            "userType": editUser?.userType,
            "name": editUser?.name?.trim(),
            "createdFrom": "ADMIN",
            "idc": editUser?.idc,
            "phone": editUser?.phone,
            "permissions": withRoleLimits(editUser?.userType, permission),
            "status": editUser?.status

        }

        if (checkStatus === false) {
            delete payload["status"];
            delete payload["userType"];
        }

        axios({
            method: 'POST',
            url: lambda + '/updateUser?appname=' + appname + '&userid=' + id + "&token=" + token,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    if (response?.data?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                        setIsLoading(false);
                    } else if (response?.data?.result === "This ACM assaigned to companies") {
                        setIsMsg(true);
                        setIsLoading(false);
                    } else if (response?.data?.result === ROLE_REFUSED) {
                        setIsLoading(false);
                        setToastMessage("Only an Admin can change users")
                        setToastType("warning")
                    } else {
                        setIsServerSync(true);
                        setIsLoading(false);
                        setUpdateSuccess(true)
                        setToastMessage("User Details Updated Successfully")
                        setToastType("success")
                    }
                }

            });
    }


    const handleUpdate = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            handleSubmit();
        }
    }
    console.log('editUser', editUser)
    const createuser = async () => {
        setIsLoading(true)

        let payload = {}
        payload = {
            "emailid": editUser?.emailid?.trim(),
            "userType": editUser?.userType,
            "name": editUser?.name?.trim(),
            "createdFrom": "ADMIN",
            "idc": editUser?.idc,
            "permissions": withRoleLimits(editUser?.userType, permission),
            "phone": editUser?.phone,

            "status": "ACTIVE",
            "createdBy": { userid: userData?.userid, username: userData?.name }
        }
        const token = localStorage.getItem("token")
        axios({
            method: 'PUT',
            url: lambda + "/addUser?appname=" + appname + "&token=" + token,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    console.log("response?.result", response)
                    if (response?.data?.result === "User already exists") {
                        setIsLoading(false)
                        // setExistMsg(true)
                        setToastMessage("User already exists")
                        setToastType("warning")
                    }
                    else if (response?.data?.result === "Invalid token or Expired") {
                        setIsLoading(false)
                        setShowSessionPopupup(true)
                    }
                    else if (response?.data?.result === ROLE_REFUSED) {
                        setIsLoading(false)
                        setToastMessage("Only an Admin can add users")
                        setToastType("warning")
                    }
                    else {
                        setIsLoading(false)
                        setSuccess(true);
                        setToastMessage("User Details Created Successfully")
                        setToastType("success")
                        // setTimeout(() => {
                        //     navigate("/users"); // Trigger API call AFTER toast is displayed
                        // }, 2000);
                        // Reset unsaved changes state
                        setHasUnsavedChanges(false);

                        // If modal was open and pending action exists, execute it
                        if (pendingAction) {
                            setShowDiscardModal(false);
                            pendingAction();
                            setPendingAction(null);
                        } else {
                            setTimeout(() => {
                                navigate("/users");
                            }, 2000);
                        }
                    }
                }

            });

    };

    const handleBack = (e) => {
        GetTimeActivity()
        guardUnsavedChanges(() => {
            if (id) {
                navigate({
                    pathname: "/users",
                    state: { search: true }
                });
            } else {
                navigate("/users")
            }
        });
    }



    const handleSelectAll = (e, updatedType, menuItemIndex, submenuIndex) => {
        const checked = e.target.checked;

        setPermission(prevState => {
            let updatedState;
            if (submenuIndex === undefined) {
                updatedState = prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        const updatedDashboard = Object.keys(menuItem.dashboard).reduce((obj, key) => {
                            obj[key] = { ...menuItem.dashboard[key], [updatedType]: checked };
                            return obj;
                        }, {});
                        return { ...menuItem, [updatedType]: checked, dashboard: updatedDashboard };
                    }
                    return menuItem;
                });
            } else if (submenuIndex === "submenus") {
                updatedState = prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        // console.log('menuItem.submenus',menuItem.submenus)
                        const updatedSubmenus = menuItem.submenus.map((submenu, j) => {

                            const kk = Object.keys(submenu.dashboard).reduce((obj, key) => {
                                obj[key] = { ...submenu.dashboard[key], [updatedType]: checked };
                                return obj
                            }, {});

                            return { ...submenu, [updatedType]: checked, dashboard: kk };

                        });
                        return { ...menuItem, [updatedType]: checked, submenus: updatedSubmenus };

                    }
                    return menuItem;
                });
            }

            else {

                updatedState = prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        const updatedSubmenus = menuItem.submenus.map((submenu, j) => {
                            if (j === submenuIndex) {

                                const kk = Object.keys(submenu.dashboard).reduce((obj, key) => {
                                    obj[key] = { ...submenu.dashboard[key], [updatedType]: checked };
                                    return obj
                                }, {});

                                return { ...submenu, [updatedType]: checked, dashboard: kk };
                            }
                            return submenu;
                        });
                        return { ...menuItem, submenus: updatedSubmenus };
                    }
                    return menuItem;
                });
            }
            markPermissionDirty(updatedState);

            return updatedState;
        });

        // console.log('permissionss',permission)
    };

    // A menu the selected user type may not have stays off and cannot be ticked.
    const locked = (item) => isMenuBlocked(editUser?.userType, item?.menu);

    const handleChangeEachItem = (e, index, subIndex, type, typeOfItem, updatedType, subSubIndex) => {
        const updatedPermission = [...permission];
        const isChecked = e.target.checked;

        if (typeOfItem === 'dashboard') {
            updatedPermission[index].dashboard[type][updatedType] = isChecked;
        } else if (typeOfItem === 'submenus') {
            updatedPermission[index].submenus[subSubIndex].dashboard[type][updatedType] = isChecked;
            if (isChecked && updatedPermission[index].dashboard) {
                Object.keys(updatedPermission[index].dashboard).forEach(key => {
                    updatedPermission[index].dashboard[key][updatedType] = true;
                });
            }
        }

        setPermission(updatedPermission);
        markPermissionDirty(updatedPermission);
    };


    //  console.log("status", editUser?.emailid);

    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />
                <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"User Not Found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert>
                {/* <Modal className="access-denied" show={showDiscardModal} centered>
                    <div className="modal-body enquiry-form">
                        <div className="container">
                            <button
                                className="close-btn"
                                onClick={() => setShowDiscardModal(false)}
                            >
                                <span className="material-icons">close</span>
                            </button>

                            <span className="material-symbols-outlined access-denied-icon">
                                warning
                            </span>

                            <h3>Unsaved Changes</h3>
                            <p>
                                You have unsaved changes.<br />
                                Do you want to discard them or update?
                            </p>

                            <div className="popup-footer d-flex gap-2">
                                <button
                                    className="fill_btn"
                                    onClick={handleDiscardChanges}
                                >
                                    Discard
                                </button>

                                <button
                                    className="fill_btn yellow-gradient"
                                    onClick={handleUpdateFromModal}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal> */}
                <Modal className="access-denied" show={showDiscardModal} centered>
                    <div className="modal-body enquiry-form">
                        <div className="container">
                            <button
                                className="close-btn"
                                onClick={() => setShowDiscardModal(false)}
                            >
                                <span className="material-icons">close</span>
                            </button>

                            <span className="material-symbols-outlined access-denied-icon">
                                warning
                            </span>

                            <h3>Unsaved Changes</h3>
                            <p>
                                You have unsaved changes.<br />
                                Do you want to discard them{id === undefined ? '' : ' or update'}?
                            </p>

                            <div className="popup-footer d-flex gap-2">
                                <button
                                    className="fill_btn"
                                    onClick={handleDiscardChanges}
                                >
                                    Discard
                                </button>

                                {id !== undefined && (
                                    <button
                                        className="fill_btn yellow-gradient"
                                        onClick={handleUpdateFromModal}
                                    >
                                        Update
                                    </button>
                                )}

                                {id === undefined && (
                                    <button
                                        className="fill_btn yellow-gradient"
                                        onClick={handleUpdateFromModal}
                                    >
                                        Create
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </Modal>
                {!invalidContent &&

                    <div className="main-content user-management create-user" id="main-content">
                        <div className="page-content" id="page-content">
                            <div className="container-fluid" id="container-fluid">
                                <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title" id="breadcrumb-title">{id === undefined ? "ADD USER" : "EDIT USER"}</h4>
                                                <p className="menu-path" id="breadcrumb-path">
                                                    <span>User Management</span> / <b id="breadcrumb-action">{id === undefined ? "ADD USER" : "EDIT USER"}</b>
                                                </p>
                                            </div>
                                            <div>
                                                <a id="back-button" onClick={handleBack} className="stroke-btn-style">
                                                    <span className="material-symbols-outlined">arrow_back</span>Back
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="create-user-block" id="create-user-block">
                                    {Object.keys(editUser)?.length > 0 ? (
                                        <>
                                            <div className="form-block" id="form-block">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="col-md-12">
                                                            <div className="mb-3 input-field">
                                                                <label className="form_label" htmlFor="user-name">NAME<span className="required">*</span></label>
                                                                <input
                                                                    id="user-name"
                                                                    name="name"
                                                                    placeholder="Enter Name"
                                                                    type="text"
                                                                    className="form-control"
                                                                    aria-invalid="false"
                                                                    onChange={(e) => handleChange(e)}
                                                                    value={editUser?.name}
                                                                />
                                                                <span id="user-name-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{nameError}</span>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="mb-3 input-field">
                                                                <label className="form_label" htmlFor="user-usertype">USER TYPE<span className="required">*</span></label>
                                                                <select
                                                                    id="user-usertype"
                                                                    className="colorselect capitalize form-control form-select"
                                                                    name="userType"
                                                                    onChange={(e) => handleChange(e)}
                                                                    value={editUser?.userType}
                                                                >
                                                                    <option value="">Select Type</option>
                                                                    {USER_TYPES.map((t) => (
                                                                        <option key={t.value} value={t.value} id={`user-${t.value.toLowerCase()}`}>{t.label}</option>
                                                                    ))}
                                                                </select>
                                                                <span id="user-usertype-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{typeError}</span>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="mb-3 input-field">
                                                                <label className="form_label" htmlFor="user-email">E-MAIL ID<span className="required">*</span></label>
                                                                <input
                                                                    id="user-email"
                                                                    name="emailid"
                                                                    placeholder="Enter Your Email"
                                                                    type="email"
                                                                    className="form-control"
                                                                    aria-invalid="false"
                                                                    value={editUser?.emailid}
                                                                    disabled={id !== undefined}
                                                                    onChange={(e) => handleChange(e)}
                                                                />
                                                                <span id="user-email-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{emailError}</span>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="mb-3 input-field">
                                                                <label className="form_label">CONTACT NUMBER <span className="required">*</span></label>
                                                                <div className="country-code">
                                                                    <select
                                                                        id="user-country-code"
                                                                        name="idc"
                                                                        value={editUser?.idc}
                                                                        className="colorselect capitalize"
                                                                        onChange={(e) => handleCountryChange(e)}
                                                                    >
                                                                        {countries && countries?.map((task, i) => (
                                                                            <option key={i} value={task.alpha3}>
                                                                                {task.alpha3}{task.countrycode}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    <input
                                                                        id="user-contact-number"
                                                                        className="form-control contact-number"
                                                                        type="tel"
                                                                        name="phone"
                                                                        value={editUser?.phone}
                                                                        placeholder="Enter Phone Number"
                                                                        onChange={(e) => handleChange(e)}
                                                                    />
                                                                    <span id="user-idc-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{IdcError}</span>
                                                                    <span id="user-phone-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{phoneError}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {id !== undefined && editUser?.status !== "PENDING REGISTRATION" &&
                                                            <div className="col-md-12">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label" htmlFor="user-status">STATUS<span className="required">*</span></label>
                                                                    <select
                                                                        id="user-status"
                                                                        className="colorselect capitalize form-control form-select"
                                                                        name="status"
                                                                        onChange={(e) => handleChange(e)}
                                                                        value={editUser?.status}
                                                                    >
                                                                        <option value="INACTIVE">INACTIVE</option>
                                                                        <option value="ACTIVE">ACTIVE</option>
                                                                    </select>
                                                                    <span id="user-status-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{statusErr}</span>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>

                                                    {permission?.length > 0 &&
                                                        <div className="col-md-6 permission-block">
                                                            <div className="permission-title"><span className="material-icons-outlined">vpn_lock</span>PERMISSIONS</div>
                                                            <div className="table-responsive">
                                                                <table className="table align-middle table-nowrap table-check" id="user-permission-table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="align-middle">MENU</th>
                                                                            <th className="align-middle">Display</th>
                                                                            <th className="align-middle">Enable</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {permission.map((item, i) => (
                                                                            <>
                                                                                <tr className="menu-titles" key={`menu-${i}`}>
                                                                                    <td className="align-middle"><div className="d-flex align-items-center"><span className="material-icons-outlined">menu_open</span>{item.menu}{locked(item) && <small className="text-muted ms-2" id={`user-permission-locked-${i}`}>Not available to {userTypeLabel(editUser?.userType)}s</small>}</div></td>
                                                                                    <td className="align-middle">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="form-check-input"
                                                                                            id={`user-permission-display-${i}`}
                                                                                            checked={item.display}
                                                                                            disabled={locked(item)}
                                                                                            onClick={(e) => item.dashboard !== undefined ? handleSelectAll(e, "display", i) : handleSelectAll(e, "display", i, "submenus")}
                                                                                        />
                                                                                    </td>
                                                                                    <td className="align-middle">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="form-check-input"
                                                                                            id={`user-permission-enable-${i}`}
                                                                                            checked={item.enable}
                                                                                            disabled={locked(item)}
                                                                                            onClick={(e) => item.dashboard !== undefined ? handleSelectAll(e, "enable", i) : handleSelectAll(e, "enable", i, "submenus")}
                                                                                        />
                                                                                    </td>
                                                                                </tr>

                                                                                {item.dashboard && Object.keys(item.dashboard).map((eachKey, j) => {
                                                                                    const eachItem = item.dashboard[eachKey];
                                                                                    return (
                                                                                        <tr key={`dashboard-${i}-${j}`}>
                                                                                            <td className="align-middle"><div className="d-flex align-items-center"><span className="material-symbols-outlined">chevron_right</span>{eachItem.menuname || eachKey}</div></td>
                                                                                            <td className="align-middle">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    className="form-check-input"
                                                                                                    id={`user-permission-display-${i}-dashboard-${j}`}
                                                                                                    checked={eachItem.display}
                                                                                                    disabled={locked(item)}
                                                                                                    onClick={(e) => handleChangeEachItem(e, i, j, eachKey, "dashboard", "display")}
                                                                                                />
                                                                                            </td>
                                                                                            <td className="align-middle">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    className="form-check-input"
                                                                                                    id={`user-permission-enable-${i}-dashboard-${j}`}
                                                                                                    checked={eachItem.enable}
                                                                                                    disabled={locked(item)}
                                                                                                    onClick={(e) => handleChangeEachItem(e, i, j, eachKey, "dashboard", "enable")}
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })}

                                                                                {item.submenus && item.submenus.map((menuItem, k) => (
                                                                                    <>
                                                                                        <tr key={`submenu-${i}-${k}`}>
                                                                                            <td className="align-middle"><div className="d-flex align-items-center"><span className="material-symbols-outlined">chevron_right</span>{menuItem.menu}</div></td>
                                                                                            <td className="align-middle">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    className="form-check-input"
                                                                                                    id={`user-permission-display-${i}-submenu-${k}`}
                                                                                                    checked={menuItem.display}
                                                                                                    disabled={locked(item)}
                                                                                                    onClick={(e) => handleSelectAll(e, "display", i, k)}
                                                                                                />
                                                                                            </td>
                                                                                            <td className="align-middle">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    className="form-check-input"
                                                                                                    id={`user-permission-enable-${i}-submenu-${k}`}
                                                                                                    checked={menuItem.enable}
                                                                                                    disabled={locked(item)}
                                                                                                    onClick={(e) => handleSelectAll(e, "enable", i, k)}
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                        {menuItem.dashboard && Object.keys(menuItem.dashboard).map((eachSubKey, m) => {
                                                                                            const eachSubItem = menuItem.dashboard[eachSubKey];
                                                                                            return (
                                                                                                <tr className="arrow-right" key={`submenu-dashboard-${i}-${k}-${m}`}>
                                                                                                    <td className="align-middle"><div className="d-flex align-items-center"><span className="material-symbols-outlined">arrow_right</span>{eachSubKey}</div></td>
                                                                                                    <td className="align-middle">
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            className="form-check-input"
                                                                                                            id={`user-permission-display-${i}-submenu-${k}-dashboard-${m}`}
                                                                                                            checked={eachSubItem.display}
                                                                                                            disabled={locked(item)}
                                                                                                            onClick={(e) => handleChangeEachItem(e, i, m, eachSubKey, "submenus", "display", k)}
                                                                                                        />
                                                                                                    </td>
                                                                                                    <td className="align-middle">
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            className="form-check-input"
                                                                                                            id={`user-permission-enable-${i}-submenu-${k}-dashboard-${m}`}
                                                                                                            checked={eachSubItem.enable}
                                                                                                            disabled={locked(item)}
                                                                                                            onClick={(e) => handleChangeEachItem(e, i, m, eachSubKey, "submenus", "enable", k)}
                                                                                                        />
                                                                                                    </td>
                                                                                                </tr>
                                                                                            )
                                                                                        })}
                                                                                    </>
                                                                                ))}
                                                                            </>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <button
                                                            id="user-submit-button"
                                                            className="fill-btn-style"
                                                            type="submit"
                                                            onClick={e => id === undefined ? handleAddUser(e) : handleUpdate(e)}
                                                            disabled={isLoading}
                                                        >
                                                            {isLoading && (
                                                                <img
                                                                    src={`${image}${appname}/images/web/rotate_right.svg`}
                                                                    className="loading-icon"
                                                                    alt="loading"
                                                                />
                                                            )}
                                                            {id === undefined ? "Create" : "Update"}
                                                        </button>
                                                    </div>
                                                    {msg && (
                                                        <span id="user-success-msg" className="errormsg" style={{ fontWeight: 'bold', color: 'green' }}>
                                                            {msg}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                        </>
                                    ) : (
                                        <div className="form-block" id="loading-block">
                                            <div className="tab-content p-3 text-muted">
                                                <div className="tab-pane active show" id="home1" role="tabpanel">
                                                    <div className="row">
                                                        <Loader />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                }



            </div>
            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

        </>
    );
};

export default EditUser;
